import Entity from './entity'

export default class ChapterType extends Entity<string>{
    name:string;
    sortNo:number;
    categoryId:number;
    categoryName:string;
    maxSortNo:number;
}